export default function MasterName({
  size = 42,
  forceHeight = null
}: {
  size?: number;
  forceHeight?: number;
}) {
  let width = size;
  let height = Math.round((size * 18) / size);

  if (forceHeight) {
    width = Math.round((forceHeight * 42) / 18);
    height = forceHeight;
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 42 18'
      fill='currentColor'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M42 5.45801H39.9804C39.8825 5.62067 39.7829 5.78484 39.6819 5.95012C38.7923 7.40496 37.7927 8.93488 36.7878 10.2686C36.2513 10.9805 35.7248 11.621 35.2229 12.1593C35.1504 11.3391 35.042 10.5975 34.9344 9.9883C34.8598 9.56627 34.7851 9.20533 34.722 8.92294H32.9512C32.9663 8.98354 32.9843 9.0578 33.0046 9.14467C33.0688 9.4192 33.1553 9.81857 33.242 10.3094C33.4161 11.2942 33.5885 12.6316 33.5895 14.0594L33.5897 14.3695H35.4633C36.3549 13.5948 37.2704 12.5248 38.1439 11.3655C39.196 9.96913 40.2289 8.38628 41.1352 6.90411C41.4382 6.40851 41.7278 5.92298 42 5.45801Z'
      />
      <path d='M2.03677 4.49358C1.46126 4.49358 1 4.11511 1 3.47699C1 2.83887 1.46126 2.5 2.03677 2.5C2.61228 2.5 3.09258 2.85867 3.09258 3.49679C3.09258 4.13491 2.63132 4.49358 2.03677 4.49358ZM1.1735 6.02948H2.91908V14.3669H1.1735V6.02948Z' />
      <path d='M14.6764 9.54115C14.6764 8.12408 14.1009 7.42654 13.1805 7.42654C12.2601 7.42654 11.6085 8.20549 11.6085 9.46194V14.3689H9.88192V9.34311C9.88192 7.94584 9.24928 7.42875 8.34793 7.42875C7.5037 7.42875 6.81394 7.98765 6.81394 9.46414V14.3711H5.10645V6.03368H6.79489V6.97106C7.31328 6.1327 8.06017 5.87305 8.80918 5.87305C9.72958 5.87305 10.4976 6.29113 11.0351 7.25051C11.4752 6.45176 12.3194 5.87305 13.3752 5.87305C15.0636 5.87305 16.4241 6.90945 16.4241 9.46414V14.3711H14.6786V9.54335L14.6764 9.54115Z' />
      <path d='M26.244 10.1794C26.244 12.5735 24.8243 14.4879 22.4841 14.4879C21.257 14.4879 20.144 13.8497 20.144 13.8497V17.1218L18.4365 17.5002V6.03164H20.144V7.46851C20.5651 6.61035 21.4283 5.93262 22.6174 5.93262C25.0337 5.93262 26.2419 7.76777 26.2419 10.1816L26.244 10.1794ZM22.3889 7.52572C21.0263 7.52572 20.144 8.80197 20.144 10.8968V12.1334C20.3366 12.294 21.1025 12.9124 22.2535 12.9124C23.7304 12.9124 24.4984 11.6163 24.4984 10.12C24.4984 8.62373 23.9039 7.52792 22.3889 7.52792V7.52572Z' />
      <path d='M29.7353 10.758V14.3689H28.0088V6.03145H29.7353V7.28789C30.004 6.40992 30.8673 5.89062 31.7687 5.89062C31.9422 5.89062 32.0564 5.89063 32.2299 5.91043C32.1157 6.48914 32.0755 6.94683 31.9422 7.52554H31.8089C29.9871 7.52554 29.7374 9.00202 29.7374 10.758H29.7353Z' />
    </svg>
  );
}
